export type { TransactionalHistoryTranslations } from "./transactional-history-pt-br";
export { TRANSACTIONAL_HISTORY_PT_BR } from "./transactional-history-pt-br";
export { TRANSACTIONAL_HISTORY_FR_FR } from "./transactional-history-fr-fr";
export { TRANSACTIONAL_HISTORY_ES_MX } from "./transactional-history-es-mx";
export { TRANSACTIONAL_HISTORY_EN_US } from "./transactional-history-en-us";
